import { FC, useEffect } from 'react';
import styles from './DailyTasksStart.module.scss';
import { useLocation, useNavigate, useSearchParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useLoggedinUser, useService } from '@hooks';
import { electrificationWizardService, notificationService, simulationService } from '@services';
import { CUSTOM_THEME, RxUtils, Tr } from '@utils';
import { Button, Stack, Typography } from '@mui/material';
import { RouterLinkButton } from '@components/common';

export const DailyTasksStart: FC = () => {
	const [queryParams] = useSearchParams();
	const navigate = useNavigate();
	const loc = useLocation();
	const user = useLoggedinUser();
	const selectedYear = +(queryParams.get('year') || new Date().getFullYear());
	const { t } = useTranslation('portal');
	const { data: simulation } = useService(() => simulationService.getLatest());
	const userCanSellVehicles = user?.isVehicleSeller() || user?.isHybridSeller();

	const isAutomaticSuggestionAvailable = () => {
		if (user?.isVehicleSeller() || user?.isHybridSeller()) {
			return !!(selectedYear && simulation?.savings?.yearlySavings);
		} else if (user?.isInfraSeller()) {
			return true;
		} else {
			return false; // TODO: what happens
		}
	};

	const onAutomaticSuggestionButtonClicked = () => {
		navigate('../processing');
	};

	useEffect(() => {
		(loc.state as any)?.auto && isAutomaticSuggestionAvailable() && onAutomaticSuggestionButtonClicked();
	}, [simulation, selectedYear]);

	return (
		<Stack
			direction="column"
			alignItems="center"
			justifyContent="space-between"
			className={styles.DailyTasksLandingLayout}
			sx={{ backgroundColor: CUSTOM_THEME.extraColors.nightBlue, color: 'common.white' }}
		>
			<Stack direction="column" spacing={11} alignItems="center">
				<Typography variant="h1" sx={{ fontFamily: 'DancingScript', fontWeight: 'bold' }}>
					{/* <Tr.Portal path="wizard.landing.title" /> */}
					Daily Activities
				</Typography>
				<Typography variant="h4" sx={{ fontWeight: 'bold', maxWidth: 480, textAlign: 'center' }}>
					{/* <Tr.Portal path="wizard.landing.subtitle" /> */}
					Run the Wizard and get him manage your vehicles for you
				</Typography>
			</Stack>
			<Stack direction="column" alignItems="center" spacing={3}>
				<Button
					data-testid="electrification-wizard-automatic-suggestion-button"
					variant="contained"
					color="primary"
					onClick={() => onAutomaticSuggestionButtonClicked()}
				>
					{/* <Tr.Portal path="wizard.landing.automatic-suggestion" /> */}
					Voltaage Daily Tasks
				</Button>
			</Stack>
		</Stack>
	);
};
